import tagTester from './_tagTester.js';

export default tagTester('Number');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isNumber.js
// module id = 964
// module chunks = 1